import {ReactNode} from 'react';
import {DetailedProps, join, tryCall} from '@esgi/ui-kit/utils';
import styles from './menu-item.module.less';

export type MenuItemProps = {
	children?: ReactNode;
	onSelect?: () => void;
} & Omit<DetailedProps<HTMLLIElement>, 'onClick'>

export const MenuItem = ({onSelect, children, className, ...props}: MenuItemProps) => (
	<li
		className={join(styles.menuItem, className)}
		role='menuitem'
		tabIndex={0}
		onClick={onSelect}
		onKeyPress={(e) => {
			if(['space', 'enter'].indexOf(e.code.toLowerCase()) >= 0) {
				tryCall(onSelect);
			}
		}}
		{...props}
	>
		{children}
	</li>
);
